export function resolveCaseTransferOriginMode(selectedAgentIds, currentActivationId) {
    if (currentActivationId == null || !Number.isFinite(currentActivationId)) {
        return 'department';
    }
    const agentIds = (selectedAgentIds ?? []).map((id) => Number(id)).filter(Number.isFinite);
    return agentIds.includes(currentActivationId) ? 'agent' : 'department';
}
export function resolveCaseTransferFromDepartmentId(assignedDepartmentId, assignedDepartment) {
    const raw = assignedDepartmentId ?? assignedDepartment?.id;
    if (raw == null || raw === '')
        return undefined;
    const numeric = Number(raw);
    return Number.isFinite(numeric) ? numeric : undefined;
}
export function resolveCaseTransferAssignmentId(assignments, originMode, currentUsername, fromDepartmentId) {
    for (const assignment of assignments) {
        if (originMode === 'agent') {
            const assignedUsername = assignment.assignedUserUsername ?? assignment.assignedUser?.username;
            if (currentUsername && assignedUsername === currentUsername) {
                const id = Number(assignment.id);
                return Number.isFinite(id) ? id : undefined;
            }
            continue;
        }
        const departmentId = assignment.assignedDepartment?.id ??
            assignment.assignedDepartmentId;
        if (fromDepartmentId != null && Number(departmentId) === fromDepartmentId) {
            const id = Number(assignment.id);
            return Number.isFinite(id) ? id : undefined;
        }
    }
    return undefined;
}
export function resolveCaseTransferTargetUsername(targetUserId, users) {
    if (targetUserId == null || targetUserId === '')
        return undefined;
    const targetId = String(targetUserId);
    const targetUser = users.find((user) => user.id === targetId);
    return targetUser?.username ?? targetUser?.id;
}
export function buildCaseTransferWorkflowRequestBody(input) {
    const body = {
        reason: input.reason,
        transferNotes: input.transferNotes,
        requiresApproval: input.requiresApproval,
    };
    if (input.caseAssignmentId != null) {
        body.caseAssignmentId = input.caseAssignmentId;
    }
    if (input.approvedByUsername) {
        body.approvedByUsername = input.approvedByUsername;
    }
    if (input.originMode === 'department') {
        if (input.fromDepartmentId != null) {
            body.fromDepartmentId = input.fromDepartmentId;
        }
        if (input.transferToUser) {
            if (input.toUsername)
                body.toUsername = input.toUsername;
        }
        else if (input.toDepartmentId != null) {
            body.toDepartmentId = input.toDepartmentId;
        }
        return body;
    }
    if (input.fromUsername) {
        body.fromUsername = input.fromUsername;
    }
    if (input.transferToUser) {
        if (input.toUsername)
            body.toUsername = input.toUsername;
    }
    else if (input.toDepartmentId != null) {
        body.toDepartmentId = input.toDepartmentId;
    }
    return body;
}
